<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="articleAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'quote_l[' + language.code + ']'" class="form-label">Quote:</label>
                      <input :id="'quote_l[' + language.code + ']'" class="form-control" :name="'quote_l[' + language.code + ']'" v-model="formData.quote_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="quote" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'author_l[' + language.code + ']'" class="form-label">Author:</label>
                      <input :id="'author_l[' + language.code + ']'" class="form-control" :name="'author_l[' + language.code + ']'" v-model="formData.author_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="author" type="text">
                    </ValidationProvider>
                    <div class="d-flex justify-content-between align-items-center">
                      <h4>Content</h4>
                      <button type="button" @click="addContent" class="btn ripple btn-main-primary mt-2">Add Content</button>
                    </div>
                    <div class="border-bottom mb-2 mt-3" v-for="(item, index) in formData.content_l" :key="index">
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`content_l[${index}].title[${language.code}]`" class="form-label d-flex justify-content-between align-items-center">
                          <span>Title:</span>
                          <button type="button" @click="removeContent(index)" class="btn ripple btn-main-primary radius" v-if="index > 0">
                            <i class="ti-close"></i>
                          </button>
                        </label>
                        <input :id="`content_l[${index}].title[${language.code}]`" class="form-control" :name="`content_l[${index}][title][${language.code}]`" v-model="formData.content_l[index].title[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                      </ValidationProvider>
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label :for="`content_l[${index}].body[${language.code}]`" class="form-label">Body:</label>
                        <ckeditor :class="checkValidation(classes, language.code)" v-model="formData.content_l[index].body[language.code]"   :name="`content_l[${index}].body[${language.code}]`"  :id="`content_l[${index}].body[${language.code}]`" :config="ckEditorConfig"></ckeditor>
                      </ValidationProvider>
                    </div>
                  </b-tab>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="slug" class="form-label">Slug:</label>
                    <input id="slug" class="form-control" name="slug" v-model="formData.slug" placeholder="slug" :class="classes" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="tags_id" class="form-label">Tags:</label>
                    <multiselect v-model="formData.tags" placeholder="Select tags" :custom-label="customLabel" :multiple="true" id="tags_id" label="title" :class="classes"  :close-on-select="true" track-by="id" :options="tags">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Article Category:</label>
                    <multiselect v-model="formData.article_category" placeholder="Select Article Category" :custom-label="customLabel" id="continent_id" :class="classes"  :close-on-select="true" track-by="id" :options="articleCategory">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Author avatar:" page="media" name="avatar" uploadType="images" type="image" :filesData="[formData.avatar]" />
                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Image:" page="media" name="media" uploadType="images" type="image" :filesData="[formData.media]" />
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../../components/ImageUpload'
const page = 'article'
const url = 'article'
export default {
  name: 'roomBaseAdd',
  data () {
    return {
      ckEditorConfig: {
        contentsLangDirection: 'ru',
        filebrowserImageUploadUrl: `${process.env.VUE_APP_WEB_API}editor/upload`,
        fileTools_requestHeaders: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.access_token}`
        }
      },
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      selectData: [],
      multipleFiles: [],
      articleCategory: [],
      tags: [],
      formData: {
        author_l: {},
        quote_l: {},
        title_l: {},
        content_l: [{
          title: {},
          body: {}
        }]
      },
      isCreate: false,
      cookieId: ''
    }
  },
  components: {
    ImageUpload
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        if (this.formData.page) {
          this.formData.slug = this.formData.page.slug
        }
        delete this.formData.page
      })
    }
    this.getCreateData().then((res) => {
      this.tags = res.tags
      this.articleCategory = res.articleCategories
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    addContent () {
      this.formData.content_l.push({
        title: {},
        body: {}
      })
    },
    removeContent (i) {
      this.formData.content_l.splice(i, 1)
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          const form = document.getElementById('articleAddForm')
          const formData = new FormData(form)
          this.formData.tags.map((item) => {
            formData.append('tags[]', item.id)
          })
          // formData.append('media', this.media)
          formData.append('article_category_id', this.formData.article_category.id)
          formData.append('page[slug]', this.formData.slug)
          if (this.formData.content_l && this.formData.content_l.length) {
            this.formData.content_l.map((item, index) => {
              Object.entries(item.body).map(([code, val], i) => {
                formData.append(`content_l[${index}][body][${code}]`, val)
              })
            })
          }
          if (this.isCreate === true) {
            this.create(formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            formData.append('_method', 'PUT')
            this.update({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
